import { useIntl } from 'react-intl';
import {
  ApiFilterOperation,
  TableCells,
  TableColumn,
  TableFilterCells,
} from '@eas/common-web';
import { ParticipantCell } from '@modules/es-file/es-file-columns';
import { FilterTextCell } from '@composite/filter/filter-cells/filter-text-cell';
import { subjectContactColumnMapper } from '@components/form/misc/label-mappers';
import { InfFile } from '@models';

export function useInfColumns() {
  const intl = useIntl();

  const columnDeliveryDate: TableColumn<InfFile> = {
    datakey: 'deliveryDate',
    name: intl.formatMessage({
      id: 'ES__INF_FILES__TABLE__COLUMN__DELIVERY_DATE',
      defaultMessage: 'Datum doručení',
    }),
    width: 150,
    CellComponent: TableCells.DateCell,
    FilterComponent: TableFilterCells.FilterDateCell,
    sortable: true,
    filterable: true,
  };

  const columnIncomingNumber: TableColumn<InfFile> = {
    datakey: 'incomingNumber',
    name: intl.formatMessage({
      id: 'ES__INF_FILES__TABLE__COLUMN__INCOMING_NUMBER',
      defaultMessage: 'Došlé číslo',
    }),
    width: 150,
    CellComponent: TableCells.TextCell,
    sortable: true,
    filterable: true,
  };

  const columnJid: TableColumn<InfFile> = {
    datakey: 'jid',
    name: intl.formatMessage({
      id: 'ES__IND_FILES__TABLE__COLUMN__JID',
      defaultMessage: 'JID',
    }),
    width: 200,
    CellComponent: TableCells.TextCell,
    sortable: true,
    filterable: true,
  };

  const columnWriters: TableColumn<InfFile> = {
    filterDialogSpan: 2,
    datakey: 'writers',
    filterkey: 'writers.contact.subject.name',
    sortkey: 'writers.contact.name',
    name: intl.formatMessage({
      id: 'ES__INF_FILES__TABLE__COLUMN__WRITERS',
      defaultMessage: 'Pisatelé',
    }),
    width: 300,
    CellComponent: ParticipantCell('writers'),
    valueMapper: subjectContactColumnMapper,
    FilterComponent: FilterTextCell,
    filterOperation: ApiFilterOperation.CONTAINS,
    filterable: true,
    sortable: true,
  };

  return { columnDeliveryDate, columnIncomingNumber, columnJid, columnWriters };
}
